import { useEffect, useState } from "react";
import VideoPlayer from "./VideoPlayer";
import DocViewer from "./DocViewer";
import TextViewer from "./TextViewer";
import * as constants from "../../utils/constants";
import ImageViewer from "./ImageViewer";
import PDFViewer from "./PDFViewer";
import MeetingViewer from "./MeetingViewer";
import "./mediaviewer.css";
import { Typography, LinearProgress, Modal, IconButton, useMediaQuery, Button, Divider, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import MaximizeIcon from "@mui/icons-material/Fullscreen";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AudioPlayer from "./AudioPlayer";
import apiInstance from "src/utils/apiAuth";
import { LoadingButton } from "@mui/lab";
import { showToast, showErrorToast } from "src/utils/Toast/SnackbarProvider";

const MediaViewer = ({ file, isRecording = false, showPlayBackSpeed = false, matches=false, documentData = null }) => {
  const [fileType, setFileType] = useState();
  const [mimeType, setMimeType] = useState();
  const [fileData, setFileData] = useState();
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [showLoadder, setShowLoadder] = useState(false);
  const [isMaximized, setIsMaximized] = useState(false);
  const [signedUrl, setSignedUrl] = useState("");
  const [mediaData, setMediaData] = useState(null);
  const [aiSummaryData, setAiSummaryData] = useState(null);
  const [loadingAiSummary, setLoadingAiSummary] = useState(false);

  useEffect(() => {
    const getFileType = (fileName) => {
      const extension = fileName.split(".").pop().toLowerCase();
      // if (extension === 'pdf') {
      //   setShowLoadder(true);
      // }
      switch (extension) {
        case "pdf":
          return "PDF";
        case "doc":
        case "docx":
        case "pptx":
        case "xls":
        case "xlsx":
          return "DOC";
        case "txt":
          return "TEXT";
        case "mp3":
        case "wav":
        case "ogg":
        case "m4a":
          return "AUDIO";
        case "mp4":
        case "mov":
          return "VIDEO";
        case "jpg":
        case "jpeg":
        case "png":
          return "IMAGE";
        default:
          return "AUDIO";
      }
    };

    // const fetchData = async () => {
    //   try {
    //     let apiUrl = constants.HTTP_METHOD + constants.HTTP_URL + constants.HTTP_PORT;
    //     const response = await axios.get(`${apiUrl}/protected-files${file.fileUrl}`, {
    //     // const response = await axios.get(`${apiUrl}/protected-files${"/other_docs/Feedback_Amit_Vaghela_10_1551706075053_uEMeRTz.docx"}`, {
    //       responseType: "blob", // Ensure response is treated as binary data
    //       headers: {
    //         Authorization: "Token " + localStorage.getItem("authToken"),
    //       },
    //       onDownloadProgress: (progressEvent) => {
    //         const { loaded, total } = progressEvent;
    //         const percentCompleted = Math.round((loaded * 100) / total);
    //         setDownloadProgress(percentCompleted);
    //       },
    //     });
    //     const contentType = response.headers["content-type"];
    //     setMimeType(contentType);
    //     setFileData(response.data);

    //     const fileType = getFileType(file.fileUrl);
    //     setFileType(fileType);
    //   } catch (error) {
    //     console.error("Error fetching file:", error);
    //   } finally {
    //     setDownloadProgress(0);
    //   }
    // };

    // fetchData();

    const fetchSignedUrl = async () => {
      try {
        const apiUrl = `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}`;
        
        // Normalize file URL - ensure it uses /media/ path, not /api/v1/media/
        let normalizedFileUrl = file.fileUrl;
        if (normalizedFileUrl) {
          // If URL already has full domain, extract just the path
          if (normalizedFileUrl.startsWith('http')) {
            try {
              const urlObj = new URL(normalizedFileUrl);
              normalizedFileUrl = urlObj.pathname;
            } catch (e) {
              // Keep as is if URL parsing fails
            }
          }
          // Fix incorrect /api/v1/media/ path to /media/
          if (normalizedFileUrl.includes('/api/v1/media/')) {
            normalizedFileUrl = normalizedFileUrl.replace('/api/v1/media/', '/media/');
          }
          // Ensure path starts with /media/ for relative paths
          if (!normalizedFileUrl.startsWith('/media/') && !normalizedFileUrl.startsWith('http')) {
            if (normalizedFileUrl.startsWith('media/')) {
              normalizedFileUrl = '/' + normalizedFileUrl;
            } else if (normalizedFileUrl.startsWith('documents/') || normalizedFileUrl.startsWith('transcriptions/')) {
              normalizedFileUrl = '/media/' + normalizedFileUrl;
            }
          }
        }
        
        const response = await apiInstance.get(`${apiUrl}/api/v1/generate-signed-url`, {
          params: { src: normalizedFileUrl },
          headers: {
            Authorization: "Token " + localStorage.getItem("authToken"),
          },
        });
        setSignedUrl(`${apiUrl}` + normalizedFileUrl);

        const extension = file.fileUrl.split(".").pop().toLowerCase();
        let serverMimeType = response.data.mime_type;

        // Derive a safe MIME type for common audio formats, especially .m4a
        if (extension === 'mp3') {
          serverMimeType = serverMimeType || 'audio/mpeg';
        } else if (extension === 'wav') {
          serverMimeType = serverMimeType || 'audio/wav';
        } else if (extension === 'ogg') {
          serverMimeType = serverMimeType || 'audio/ogg';
        } else if (extension === 'm4a') {
          // Some production setups return a generic or wrong type for .m4a
          // Force a proper audio MIME so the <audio> element can play it.
          if (!serverMimeType || !serverMimeType.startsWith('audio/')) {
            serverMimeType = 'audio/mp4';
          }
        }

        setMimeType(serverMimeType);

        const fileType = getFileType(file.fileUrl);
        setFileType(fileType);
        if(serverMimeType?.indexOf('pdf') < 0) {
          setShowLoadder(false);
        }
      } catch (error) {
        console.error("Error fetching signed URL:", error);
      }
    };
    if (isRecording === false) {
      if (fileType && fileType !== "PDF") setShowLoadder(true);
      fetchSignedUrl();
    }
  }, [file.fileUrl]);

  const onModalToggleHandler = (status) => {
    const loadingTime = 2000;
    setIsMaximized(status);
    if (status === true) {
      if (fileType && fileType !== "PDF") setShowLoadder(true);
      if (!isRecording && mimeType?.indexOf('pdf') < 0) {
        setTimeout(() => {
          setShowLoadder(false);
        }, loadingTime);
      }
    } else {
      setShowLoadder(false);
    }
    setMediaData(renderMediaViewer(fileType, signedUrl, mimeType));
  };

  const isMediaContentLoaded = () => {
    setShowLoadder(false);
  }

  // Check if AI summary should be shown initially
  useEffect(() => {
    if (fileType === "AUDIO" && documentData?.has_ai_summary && documentData?.ai_summary) {
      setAiSummaryData({
        document_id: documentData.id,
        ai_summary: documentData.ai_summary,
        ai_transcription: documentData.ai_transcription,
        generated_at: documentData.ai_summary_generated_at
      });
    }
  }, [fileType, documentData]);

  const handleGetAiSummary = async () => {
    if (!documentData?.id) {
      showErrorToast('Document ID is missing');
      return;
    }

    try {
      setLoadingAiSummary(true);
      const response = await apiInstance.post(`company-documents/get-ai-summary/`, {
        document_id: documentData.id}, {
          headers: {
            Authorization: `Token ${localStorage.getItem('authToken')}`
          }
        }
      );

      if (response.status === 200 && response.data?.data) {
        setAiSummaryData(response.data.data);
        showToast('AI Summary loaded successfully', 'success');
      } else {
        showErrorToast('Failed to get AI summary');
      }
    } catch (error) {
      console.error('Error fetching AI summary:', error);
      showErrorToast(error.response?.data?.message || 'Failed to get AI summary');
    } finally {
      setLoadingAiSummary(false);
    }
  };

  // Manual markdown parser for basic formatting
  const parseMarkdown = (text) => {
    if (!text) return null;

    const lines = text.split('\n');
    const elements = [];
    let currentList = null;

    lines.forEach((line, index) => {
      const trimmedLine = line.trim();

      // Headings
      if (trimmedLine.startsWith('### ')) {
        if (currentList) {
          elements.push(currentList);
          currentList = null;
        }
        elements.push(
          <Typography key={index} variant="h6" sx={{ fontSize: '1.1rem', fontWeight: 600, mt: 2, mb: 1 }}>
            {parseInlineMarkdown(trimmedLine.substring(4))}
          </Typography>
        );
      } else if (trimmedLine.startsWith('## ')) {
        if (currentList) {
          elements.push(currentList);
          currentList = null;
        }
        elements.push(
          <Typography key={index} variant="h5" sx={{ fontSize: '1.3rem', fontWeight: 600, mt: 2, mb: 1 }}>
            {parseInlineMarkdown(trimmedLine.substring(3))}
          </Typography>
        );
      } else if (trimmedLine.startsWith('# ')) {
        if (currentList) {
          elements.push(currentList);
          currentList = null;
        }
        elements.push(
          <Typography key={index} variant="h4" sx={{ fontSize: '1.5rem', fontWeight: 600, mt: 2, mb: 1 }}>
            {parseInlineMarkdown(trimmedLine.substring(2))}
          </Typography>
        );
      }
      // Bullet points
      else if (trimmedLine.startsWith('- ') || trimmedLine.startsWith('* ')) {
        if (!currentList) {
          currentList = [];
        }
        currentList.push(
          <Box key={index} component="li" sx={{ mb: 0.5 }}>
            {parseInlineMarkdown(trimmedLine.substring(2))}
          </Box>
        );
      }
      // Empty line
      else if (trimmedLine === '') {
        if (currentList) {
          elements.push(
            <Box key={`list-${index}`} component="ul" sx={{ margin: '8px 0', paddingLeft: '20px', mb: 1 }}>
              {currentList}
            </Box>
          );
          currentList = null;
        }
      }
      // Regular paragraph
      else {
        if (currentList) {
          elements.push(
            <Box key={`list-${index}`} component="ul" sx={{ margin: '8px 0', paddingLeft: '20px', mb: 1 }}>
              {currentList}
            </Box>
          );
          currentList = null;
        }
        elements.push(
          <Typography key={index} variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
            {parseInlineMarkdown(trimmedLine)}
          </Typography>
        );
      }
    });

    // Close any remaining list
    if (currentList) {
      elements.push(
        <Box key="list-final" component="ul" sx={{ margin: '8px 0', paddingLeft: '20px', mb: 1 }}>
          {currentList}
        </Box>
      );
    }

    return elements.length > 0 ? <Box>{elements}</Box> : <Typography variant="body2">{text}</Typography>;
  };

  // Parse inline markdown (bold, italic)
  const parseInlineMarkdown = (text) => {
    if (!text) return text;

    const parts = [];
    let currentIndex = 0;
    let key = 0;

    // Match bold (**text** or __text__)
    const boldRegex = /(\*\*|__)(.*?)\1/g;
    let match;

    while ((match = boldRegex.exec(text)) !== null) {
      // Add text before the match
      if (match.index > currentIndex) {
        parts.push(
          <span key={key++}>{text.substring(currentIndex, match.index)}</span>
        );
      }
      // Add bold text
      parts.push(
        <strong key={key++} style={{ fontWeight: 600 }}>
          {match[2]}
        </strong>
      );
      currentIndex = match.index + match[0].length;
    }

    // Add remaining text
    if (currentIndex < text.length) {
      parts.push(
        <span key={key++}>{text.substring(currentIndex)}</span>
      );
    }

    return parts.length > 0 ? <>{parts}</> : text;
  };

  const renderMediaViewer = (fileType, fileData, mimeType) => {
    if (isRecording) {
      fileType = 'REC';
    }
    switch (fileType) {
      case "PDF":
        return <PDFViewer src={fileData} mimeType={mimeType} isMediaContentLoaded={isMediaContentLoaded}/>;
      case "AUDIO":
        return <AudioPlayer src={fileData} mimeType={mimeType} showPlayBackSpeed={showPlayBackSpeed} matches={matches}/>;
      case "DOC":
        return <DocViewer src={fileData} />;
      case "TEXT":
        return <TextViewer src={fileData} />;
      case "IMAGE":
        return <ImageViewer src={fileData} />;
      case "VIDEO":
        return <VideoPlayer src={fileData} mimeType={mimeType} />;
      case "REC":
         return <MeetingViewer src={file} mimeType='rec' matches={matches}/>;
      default:
        return null;
    }
  };

  const renderLoaderHtml = () => {
    return (
      <div
        className="overlay"
        style={{
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          position: "absolute",
        }}
      >
        <div
          className="overlay-content"
          style={{
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            position: "absolute",
          }}
        >
          <Box
            sx={{
              width: "75px",
              height: "75px",
              display: "inline-block",
            }}
          >
            <CircularProgress />
          </Box>
        </div>
      </div>
    );
  };

  return (
    <>
      {downloadProgress ? (
        <>
          <LinearProgress
            variant="determinate"
            value={downloadProgress}
            style={{ height: "10px", borderRadius: "8px" }}
          />
          <Typography
            style={{
              color: "black",
              fontWeight: "bold",
              top: "0",
              bottom: "0",
              alignSelf: "center",
              width: "100%",
              textAlign: "center",
            }}
          >
            Loading... {downloadProgress}%
          </Typography>
        </>
      ) : (
        <>
          <div className="media-viewer" style={{ width: "100%", height: matches ? isRecording ? "320px" : "" : "100%", position: 'relative' }} >
            {/* {!isMaximized && fileType !== "AUDIO" && (
              <IconButton
                onClick={() => onModalToggleHandler(true)}
                style={{ display: "flex", top: 0, right: 5, float:'right', position: isRecording ? 'absolute' : '' }}
              >
                <MaximizeIcon />
              </IconButton>
            )} */}
            {renderMediaViewer(fileType, signedUrl, mimeType)}
            {/* {showLoadder && !isMaximized && renderLoaderHtml()} */}
            
            {/* AI Summary Section - Only for Audio files in non-modal view */}
            {fileType === "AUDIO" && documentData && !isMaximized && (
              <Box sx={{ 
                mt: 2, 
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden'
              }}>
                <Divider sx={{ mb: 2 }} />
                
                {/* Show button if has_ai_summary is false or no summary data yet */}
                {(!documentData.has_ai_summary || !aiSummaryData) && (
                  <LoadingButton
                    onClick={handleGetAiSummary}
                    loading={loadingAiSummary}
                    variant="outlined"
                    startIcon={<AutoAwesomeIcon />}
                    fullWidth
                    sx={{ mb: 2 }}
                  >
                    Get AI Summary
                  </LoadingButton>
                )}
                
                {/* Show AI Summary if available */}
                {aiSummaryData && (
                  <>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                      AI Summary
                    </Typography>
                    
                    {aiSummaryData.ai_summary && (
                      <Accordion defaultExpanded sx={{ mb: 1, '& .MuiAccordionDetails-root': { maxHeight: '400px', overflowY: 'auto' } }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            Summary
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box
                            sx={{ 
                              wordBreak: 'break-word',
                              overflowWrap: 'break-word',
                              maxWidth: '100%'
                            }}
                          >
                            {parseMarkdown(aiSummaryData.ai_summary)}
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    )}
                    
                    {aiSummaryData.ai_transcription && (
                      <Accordion sx={{ '& .MuiAccordionDetails-root': { maxHeight: '400px', overflowY: 'auto' } }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            Transcription
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box
                            sx={{ 
                              wordBreak: 'break-word',
                              overflowWrap: 'break-word',
                              maxWidth: '100%'
                            }}
                          >
                            {parseMarkdown(aiSummaryData.ai_transcription)}
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    )}
                    
                    {aiSummaryData.generated_at && (
                      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                        Generated at: {new Date(aiSummaryData.generated_at).toLocaleString()}
                      </Typography>
                    )}
                  </>
                )}
              </Box>
            )}
          </div>

          <Modal
            open={isMaximized}
            fullScreen
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            onClose={() => onModalToggleHandler(false)}
          >
            <>
              {showLoadder && !isRecording && renderLoaderHtml()}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: fileType === "AUDIO" ? "auto" : fileType === "PDF" ? "90%" : "75%",
                  maxHeight: fileType === "AUDIO" ? "90vh" : fileType === "PDF" ? "90%" : "75%",
                  width: fileType === "AUDIO" ? "90%" : fileType === "PDF" ? "90%" : "75%",
                  maxWidth: fileType === "AUDIO" ? "800px" : "90%",
                  backgroundColor: fileType === "AUDIO" ? "#ffffff" : "transparent",
                  borderRadius: fileType === "AUDIO" ? "12px" : "0",
                  boxShadow: fileType === "AUDIO" ? "0 8px 32px rgba(0,0,0,0.12)" : "none",
                  padding: fileType === "AUDIO" ? "24px" : "0",
                  overflow: fileType === "AUDIO" ? "hidden" : "auto",
                }}
                className="media-container"
              >
                <div>
                  <IconButton
                    onClick={() => onModalToggleHandler(false)}
                    style={{
                      position: "absolute",
                      top: fileType === "AUDIO" ? 12 : 5,
                      right: fileType === "AUDIO" ? 12 : 10,
                      backgroundColor: fileType === "AUDIO" ? "#f5f5f5" : "transparent",
                      color: fileType === "AUDIO" ? "#333" : "inherit",
                    }}
                    sx={{
                      '&:hover': {
                        backgroundColor: fileType === "AUDIO" ? "#e0e0e0" : "rgba(0,0,0,0.1)",
                      }
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    width: "100%",
                    overflowY: fileType === "AUDIO" ? "auto" : "visible",
                    maxHeight: fileType === "AUDIO" ? "calc(90vh - 100px)" : "none",
                    flex: fileType === "AUDIO" ? "1 1 auto" : "none",
                    minHeight: 0,
                  }}
                >
                  {fileType === "AUDIO" && (
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      mb: 3,
                      pb: 2,
                      borderBottom: '1px solid #e0e0e0',
                      width: '100%'
                    }}>
                      <Box sx={{
                        width: 48,
                        height: 48,
                        borderRadius: '12px',
                        backgroundColor: '#e3f2fd',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <HeadphonesIcon sx={{ fontSize: 28, color: '#1976d2' }} />
                      </Box>
                      <Box>
                        <Typography variant="h6" sx={{
                          fontSize: '1.1rem',
                          fontWeight: 600,
                          color: '#333',
                          mb: 0.5
                        }}>
                          Audio Player
                        </Typography>
                        <Typography variant="caption" sx={{
                          color: '#666',
                          fontSize: '0.875rem'
                        }}>
                          Playing audio file
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  {mediaData}
                  
                  {/* AI Summary Section - Only for Audio files */}
                  {fileType === "AUDIO" && documentData && (
                    <Box sx={{ 
                      mt: 3, 
                      width: '100%',
                      maxWidth: '100%',
                      overflow: 'hidden'
                    }}>
                      <Divider sx={{ mb: 2 }} />
                      
                      {/* Show button if has_ai_summary is false or no summary data yet */}
                      {(!documentData.has_ai_summary || !aiSummaryData) && (
                        <LoadingButton
                          onClick={handleGetAiSummary}
                          loading={loadingAiSummary}
                          variant="outlined"
                          startIcon={<AutoAwesomeIcon />}
                          fullWidth
                          sx={{ mb: 2 }}
                        >
                          Get AI Summary
                        </LoadingButton>
                      )}
                      
                      {/* Show AI Summary if available */}
                      {aiSummaryData && (
                        <>
                          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                            AI Summary
                          </Typography>
                          
                          {aiSummaryData.ai_summary && (
                            <Accordion defaultExpanded sx={{ mb: 1, '& .MuiAccordionDetails-root': { maxHeight: '400px', overflowY: 'auto' } }}>
                              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                  Summary
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Box
                                  sx={{ 
                                    '& p': { 
                                      margin: '0 0 8px 0',
                                      fontSize: '0.875rem',
                                      lineHeight: 1.6
                                    },
                                    '& ul, & ol': {
                                      margin: '0 0 8px 0',
                                      paddingLeft: '20px'
                                    },
                                    '& li': {
                                      marginBottom: '4px',
                                      fontSize: '0.875rem'
                                    },
                                    '& strong': {
                                      fontWeight: 600
                                    },
                                    '& em': {
                                      fontStyle: 'italic'
                                    },
                                    '& code': {
                                      backgroundColor: '#f5f5f5',
                                      padding: '2px 4px',
                                      borderRadius: '3px',
                                      fontSize: '0.8rem',
                                      fontFamily: 'monospace'
                                    },
                                    '& pre': {
                                      backgroundColor: '#f5f5f5',
                                      padding: '12px',
                                      borderRadius: '4px',
                                      overflow: 'auto',
                                      fontSize: '0.8rem'
                                    },
                                    '& pre code': {
                                      backgroundColor: 'transparent',
                                      padding: 0
                                    },
                                    '& blockquote': {
                                      borderLeft: '3px solid #ddd',
                                      paddingLeft: '12px',
                                      margin: '8px 0',
                                      color: '#666'
                                    },
                                    '& h1, & h2, & h3, & h4, & h5, & h6': {
                                      margin: '12px 0 8px 0',
                                      fontWeight: 600
                                    },
                                    '& h1': { fontSize: '1.5rem' },
                                    '& h2': { fontSize: '1.3rem' },
                                    '& h3': { fontSize: '1.1rem' },
                                    '& table': {
                                      borderCollapse: 'collapse',
                                      width: '100%',
                                      margin: '8px 0'
                                    },
                                    '& th, & td': {
                                      border: '1px solid #ddd',
                                      padding: '8px',
                                      textAlign: 'left'
                                    },
                                    '& th': {
                                      backgroundColor: '#f5f5f5',
                                      fontWeight: 600
                                    },
                                    wordBreak: 'break-word',
                                    overflowWrap: 'break-word',
                                    maxWidth: '100%'
                                  }}
                                >
                                  {parseMarkdown(aiSummaryData.ai_summary)}
                                </Box>
                              </AccordionDetails>
                            </Accordion>
                          )}
                          
                          {aiSummaryData.ai_transcription && (
                            <Accordion sx={{ '& .MuiAccordionDetails-root': { maxHeight: '400px', overflowY: 'auto' } }}>
                              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                  Transcription
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Box
                                  sx={{ 
                                    wordBreak: 'break-word',
                                    overflowWrap: 'break-word',
                                    maxWidth: '100%'
                                  }}
                                >
                                  {parseMarkdown(aiSummaryData.ai_transcription)}
                                </Box>
                              </AccordionDetails>
                            </Accordion>
                          )}
                          
                          {aiSummaryData.generated_at && (
                            <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                              Generated at: {new Date(aiSummaryData.generated_at).toLocaleString()}
                            </Typography>
                          )}
                        </>
                      )}
                    </Box>
                  )}
                </div>
              </div>
            </>
          </Modal>
        </>
      )}
    </>
  );
};

export default MediaViewer;